import { useState } from "react";
import { ITradingIdeaSectionDict, IWikifolioDetailProps } from "src/api/server/wf-detail.types";
import { Typography } from "src/components-mui/base/typography/typography";
import { ExpandableText } from "src/components-mui/common/expandable-text/expandable-text";

const TRADING_IDEA_CONTENT_TEST_ID = "trading-idea-content";
const TRADING_IDEA_TOGGLE_TRANSLATION_TEST_ID = "trading-idea-toggle-translation";

export interface ITradingIdeaProps {
    dict: ITradingIdeaSectionDict;
    isTranslationNecessary: IWikifolioDetailProps["data"]["isTranslationNecessary"];
    description: IWikifolioDetailProps["data"]["wikifolio"]["description"];
}

export const TradingIdea = ({ dict, isTranslationNecessary, description }: ITradingIdeaProps) => {
    const [isTranslatedDescriptionDisplayed, setIsTranslatedDescriptionDisplayed] = useState(true);

    return (
        <>
            <ExpandableText
                text={isTranslatedDescriptionDisplayed ? description.content : description.originalContent}
                noOfLines={4}
                data-test-id={TRADING_IDEA_CONTENT_TEST_ID}
            />

            {isTranslationNecessary &&
                (description.isTranslationAvailable ? (
                    <>
                        <Typography component="p" sx={{ m: 0, color: "gray.400", whiteSpace: "pre-line" }}>
                            {isTranslatedDescriptionDisplayed ? dict.contentTranslatedByWikifolio : dict.originalWikifolioDescriptionContent}
                        </Typography>
                        <Typography
                            component="button"
                            type="button"
                            onClick={() => setIsTranslatedDescriptionDisplayed(isDisplayed => !isDisplayed)}
                            data-test-id={TRADING_IDEA_TOGGLE_TRANSLATION_TEST_ID}
                            sx={{
                                p: 0,
                                border: 0,
                                backgroundColor: "transparent",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "sm",
                                textAlign: "left",
                            }}
                        >
                            {isTranslatedDescriptionDisplayed ? dict.showOriginalText : dict.showTranslatedText}
                        </Typography>
                    </>
                ) : (
                    <Typography component="p" sx={{ m: 0, color: "gray.400" }}>
                        {dict.contentNotAvailableInLanguage}
                    </Typography>
                ))}
        </>
    );
};
